export const checkMatch = (value: string | number, searchKeyWord: string) => {
  return value.toString().toLowerCase().includes(searchKeyWord.toLowerCase());
};

export const isObjectEmpty = (obj: {}) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};
